import Content, {IContent} from "@/model/Content/Content"
import hasInsuranceFamily, {IHasInsuranceFamily} from "@/model/mixins/InsuranceFamily/hasInsuranceFamily"



class InsuranceFamilyContentBase extends Content {
    private name: string

    constructor(name: string) {
        super()
        this.name = name
    }

    public getName(): string {
        return this.name
    }

}

export interface IInsuranceFamilyContent extends InsuranceFamilyContentBase, IContent, IHasInsuranceFamily {
    getName(): string
}

const InsuranceFamilyContent: Constructor<IInsuranceFamilyContent> = hasInsuranceFamily(InsuranceFamilyContentBase)

export default InsuranceFamilyContent